import { Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { StyledAccidenteader } from "../../../../styled/accident";

const AccidentHeader = () => {
  const accident = useSelector((state) => state.accidentDashboard.accident);
  return (
    <StyledAccidenteader.Container>
      <StyledAccidenteader.Name>
        {accident.apellidoTrabajador}, {accident.nombreTrabajador}{" "}
        {accident.documento}
      </StyledAccidenteader.Name>
      <Typography>{accident.art}</Typography>
      <StyledAccidenteader.Alta>
        {accident.alta ? accident.estado : null}
      </StyledAccidenteader.Alta>
      <Typography>Siniestro {accident.siniestro}</Typography>
    </StyledAccidenteader.Container>
  );
};

export default AccidentHeader;
